const getStates = /* GraphQL */ `
  query getStates($countryCode: String) {
    states(countryCode: $countryCode) {
      code: stateCode
      name
    }
  }
`;

export default getStates;
